import React from "react";
import { getProgressPoint } from "../../../helpers/bar-helper";
import { BarDisplay } from "./bar-display";
import { BarDateHandle } from "./bar-date-handle";
import { BarProgressHandle } from "./bar-progress-handle";
import { TaskItemProps } from "../task-item";
import styles from "./bar.module.css";

export const Bar: React.FC<TaskItemProps> = ({
  task,
  isProgressChangeable,
  isDateChangeable,
  rtl,
  onEventStart,
  isSelected,
  onMilestoneMouseEnter,
  onMilestoneMouseLeave,
}) => {

  const progressPoint = getProgressPoint(
    +!rtl * task.progressWidth + task.progressX ,
    task.y+2,
    task.height -2
  );
  const handleHeight = task.height - 2;
  return (
    <g className={styles.barWrapper} tabIndex={0} data-taskid={task.id} data-type="Task">
      <BarDisplay
        task={task}
        x={task.x1}
        y={task.y}
        width={task.x2 - task.x1}
        height={task.height}
        progressX={task.progressX}
        progressWidth={task.progressWidth}
        barCornerRadius={task.barCornerRadius}
        styles={task.styles}
        isSelected={isSelected}
        onMouseDown={e => {
          isDateChangeable &&  onEventStart(e.button == 0 ? "move":"", task, e);
        }}
      />
      <g className="handleGroup">
        {isDateChangeable && (
          <g>
            {/* left */}
            {/* <BarDateHandle
              x={task.x1 }
              y={task.y + 1}
              width={task.handleWidth-5}
              height={handleHeight}
              barCornerRadius={task.barCornerRadius}
              onMouseDown={e => {
                onEventStart("start", task, e);
              }}
            /> */}
            {/* right */}
            <BarDateHandle
              x={task.x2 - 2}
              y={task.y + 1}
              width={task.handleWidth-5}
              height={handleHeight}
              barCornerRadius={task.barCornerRadius}
              onMouseDown={e => {
                onEventStart("end", task, e);
              }}
            />
          </g>
        )}
        {isProgressChangeable && (
          <BarProgressHandle
            progressPoint={progressPoint}
            onMouseDown={e => {
              onEventStart("progress", task, e);
            }}
          />
        )}
      </g>

      {/* Render Milestone Diamonds on the bar */}
      {task.milestones && 
       task.milestones.length > 0 && 
       (task.id.endsWith("-act") || (!task.id.endsWith("-recalc") && (!task.id.endsWith("-est") || !task.baseLineTask?.length))) &&

       task.milestones.reduce((acc, current) => {
         const existing = acc.find((g: any) => Math.abs(g.x - current.x) < 2);
         if (existing) existing.items.push(current);
         else acc.push({ x: current.x, items: [current] });
         return acc;
       }, [] as any[]).map((group: any) => {
        const isMultiple = group.items.length > 1;
        const milestone = group.items[0];
        const diamondSize = isMultiple ? 16 : 12;
        const centerY = task.y + task.height / 2;
        const transform = `rotate(45 ${milestone.x} ${centerY})`;

        const synthesizedMilestone = {
          ...milestone,
          id: group.items.map((m: any) => m.id).join(","),
          name: group.items.map((m: any) => m.name).join(", ")
        };

        return (
          <g key={synthesizedMilestone.id} className="milestone-marker">
            {/* Milestone Diamond */}
            <rect
              x={milestone.x - diamondSize / 2}
              y={centerY - diamondSize / 2}
              width={diamondSize}
              height={diamondSize}
              fill={milestone.color || task.styles.backgroundColor}
              stroke="#ffffff"
              strokeWidth="1.5"
              transform={transform}
              className="pointer-events-none"
              style={{ filter: 'drop-shadow(0px 1px 2px rgba(0,0,0,0.25))' }}
            />
            {isMultiple && (
              <text
                x={milestone.x}
                y={centerY + 3}
                textAnchor="middle"
                fontSize="9"
                fontWeight="bold"
                fill="#ffffff"
                className="pointer-events-none select-none"
                style={{ filter: "drop-shadow(0px 1px 1px rgba(0,0,0,0.5))" }}
              >
                {group.items.length}
              </text>
            )}
            {onMilestoneMouseEnter && onMilestoneMouseLeave && (
              <rect
                data-milestone-hit="true"
                x={milestone.x - 10}
                y={centerY - 10}
                width={20}
                height={20}
                fill="transparent"
                className="cursor-pointer"
                style={{ pointerEvents: "auto" }}
                onMouseEnter={(e) => {
                  e.stopPropagation();
                  onMilestoneMouseEnter(e, synthesizedMilestone);
                }}
                onMouseLeave={(e) => {
                  e.stopPropagation();
                  onMilestoneMouseLeave(e);
                }}
              />
            )}
          </g>
        );
      })}
    </g>
  );
};
